const hasBrandingValue = (value) =>
  typeof value === "string" ? value.trim().length > 0 : Boolean(value);

export const needsPlatformTabBranding = (theme) =>
  !hasBrandingValue(theme?.tabName) ||
  !hasBrandingValue(theme?.favicon?.light) ||
  !hasBrandingValue(theme?.favicon?.dark);

export const applyPlatformTabBrandingFallback = (
  organizationTheme = {},
  platformTheme = {},
) => {
  const organizationFavicon = organizationTheme.favicon || {};
  const platformFavicon = platformTheme.favicon || {};

  return {
    ...organizationTheme,
    tabName: hasBrandingValue(organizationTheme.tabName)
      ? organizationTheme.tabName
      : platformTheme.tabName || "",
    favicon: {
      ...platformFavicon,
      ...organizationFavicon,
      light: hasBrandingValue(organizationFavicon.light)
        ? organizationFavicon.light
        : platformFavicon.light || "",
      dark: hasBrandingValue(organizationFavicon.dark)
        ? organizationFavicon.dark
        : platformFavicon.dark || "",
    },
  };
};

export const resolveTabBranding = (
  organizationTheme = {},
  platformTheme = {},
  frontendFallback = {},
) =>
  applyPlatformTabBrandingFallback(
    organizationTheme,
    applyPlatformTabBrandingFallback(platformTheme, frontendFallback),
  );
